import { __extends } from "tslib";
import { AbstractMethodError } from '@awayjs/core';
import { MethodBase, _Shader_MethodBase } from '../methods/MethodBase';
var ShadowMapperBase = /** @class */ (function (_super) {
    __extends(ShadowMapperBase, _super);
    function ShadowMapperBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._epsilon = .02;
        _this._alpha = 1;
        _this.autoUpdate = true;
        return _this;
    }
    Object.defineProperty(ShadowMapperBase.prototype, "textureMap", {
        get: function () {
            return this._textureMap;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShadowMapperBase.prototype, "alpha", {
        /**
         * The "transparency" of the shadows. This allows making shadows less strong.
         */
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            this._alpha = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShadowMapperBase.prototype, "light", {
        get: function () {
            return this._light;
        },
        set: function (value) {
            if (this._light == value)
                return;
            this._light = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShadowMapperBase.prototype, "epsilon", {
        /**
         * A small value to counter floating point precision errors when comparing values in the shadow map with the
         * calculated depth value. Increase this if shadow banding occurs, decrease it if the shadow seems to be too detached.
         */
        get: function () {
            return this._epsilon;
        },
        set: function (value) {
            this._epsilon = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ShadowMapperBase.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (value) {
            if (this._size == value)
                return;
            this._size = value;
            this._updateSize();
        },
        enumerable: false,
        configurable: true
    });
    ShadowMapperBase.prototype.update = function (node) {
        this._updateProjection(node.view.projection);
        this._renderMap(node);
    };
    ShadowMapperBase.prototype._updateProjection = function (projection) {
        throw new AbstractMethodError();
    };
    ShadowMapperBase.prototype._renderMap = function (node) {
        throw new AbstractMethodError();
    };
    ShadowMapperBase.prototype._updateSize = function () {
        throw new AbstractMethodError();
    };
    ShadowMapperBase.prototype.dispose = function () {
        this._light = null;
    };
    return ShadowMapperBase;
}(MethodBase));
export { ShadowMapperBase };
/**
 * _Shader_ShadowMapperBase provides an abstract method for simple (non-wrapping) shadow map methods.
 */
var _Shader_ShadowMapperBase = /** @class */ (function (_super) {
    __extends(_Shader_ShadowMapperBase, _super);
    function _Shader_ShadowMapperBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.autoUpdate = true;
        return _this;
    }
    /**
     * @inheritDoc
     */
    _Shader_ShadowMapperBase.prototype._cleanCompilationData = function () {
        _super.prototype._cleanCompilationData.call(this);
        this._depthMapCoordReg = null;
    };
    Object.defineProperty(_Shader_ShadowMapperBase.prototype, "texture", {
        get: function () {
            return this._texture;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(_Shader_ShadowMapperBase.prototype, "depthMapCoordReg", {
        /**
         * Wrappers that override the vertex shader need to set this explicitly
         */
        get: function () {
            return this._depthMapCoordReg;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Creates a new _Shader_ShadowMapperBase object.
     */
    _Shader_ShadowMapperBase.prototype.init = function (mapper, shader) {
        _super.prototype.init.call(this, mapper, shader);
        this._mapper = mapper;
        this._shader = shader;
        this._shader.renderMaterial.renderElements.renderer._addMapper(this._mapper);
    };
    /**
     *
     */
    _Shader_ShadowMapperBase.prototype.onClear = function () {
        _super.prototype.onClear.call(this);
        this._shader.renderMaterial.renderElements.renderer._removeMapper(this._mapper);
    };
    /**
     * @inheritDoc
     */
    _Shader_ShadowMapperBase.prototype._initVO = function (chunkVO) {
        this._texture = this._shader.abstractions.getAbstraction(this._mapper.textureMap);
        this._texture._initVO(chunkVO);
    };
    _Shader_ShadowMapperBase.prototype._initConstants = function () {
        this._texture._initConstants();
    };
    /**
     * @inheritDoc
     */
    _Shader_ShadowMapperBase.prototype._getFragmentCode = function (targetReg, regCache, sharedRegs) {
        var dataReg = regCache.getFreeFragmentConstant();
        this._fragmentAlphaIndex = dataReg.index * 4;
        return 'add ' + targetReg + '.w, ' + targetReg + '.w, ' + dataReg + '.x\n' + // add alpha
            'sat ' + targetReg + '.w, ' + targetReg + '.w\n';
    };
    /**
     * @inheritDoc
     */
    _Shader_ShadowMapperBase.prototype._activate = function () {
        var fragmentData = this._shader.fragmentConstantData;
        var index = this._fragmentAlphaIndex;
        fragmentData[index] = 1 - this._mapper.alpha;
        this._texture.activate();
    };
    /**
     * @inheritDoc
     */
    _Shader_ShadowMapperBase.prototype._setRenderState = function (renderState) {
        this._texture._setRenderState(renderState);
    };
    return _Shader_ShadowMapperBase;
}(_Shader_MethodBase));
export { _Shader_ShadowMapperBase };
